// Logout = DELETE /logout ke server (menghapus sesi). Halaman "/" di app.<domain> langsung memindahkan browser ke domain utama
// (muat ulang penuh), yang MEMBATALKAN permintaan yang belum selesai: sesi tidak terhapus dan pengguna "masuk lagi" sendiri.
// Maka pengalihan menunggu logout yang sedang berjalan, dengan batas waktu supaya tidak menggantung bila jaringan putus.
let berjalan = null;

export const catatLogout = (permintaan) => {
  const p = Promise.resolve(permintaan).catch(() => {}).then(() => { if (berjalan === p) berjalan = null; });
  berjalan = p;
  return p;
};

export const tungguLogout = (batasMs = 4000) => {
  if (!berjalan) return Promise.resolve();
  let pewaktu;
  const habis = new Promise((selesai) => { pewaktu = setTimeout(selesai, batasMs); });
  return Promise.race([berjalan, habis]).then(() => clearTimeout(pewaktu));
};
